<div class="wrapper">
    <div id="content">
      <app-orders-list></app-orders-list>
      <app-spinner></app-spinner>
    </div>
</div>
